import { useTranslation } from 'react-i18next';

import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OrganisationArea } from '../../organisation-area';
import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import { ProjectBillingCell } from '../ProjectBillingCell';
import schema from '../schemata/projectHours-table-schema.json';

import {
  useProjectHoursTableActions,
  useProjectHoursTableDefaultColumnFilters,
} from './hooks';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];
const defaultGrouping = ['project.id'];

export function ProjectHoursTable(props: IEntityTableV8) {
  const { entity: entityType } = schema as never;

  const { t } = useTranslation();
  const defaultColumnFilters = useProjectHoursTableDefaultColumnFilters();
  const dataTable = useEntityDataTableV8<TimeTracking, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    enableURLState: false,
    defaultGrouping,
    defaultColumnFilters,
    cells: {
      ProjectBilling: ProjectBillingCell,
    },
    forceSelectionColumn: true,
  });

  const actions = useProjectHoursTableActions(dataTable.selectedEntities);

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      actions={actions}
      listEntityType={Entities.timeTracking}
      overrides={{
        areas: {
          left: {
            title: t('COMMON.ORGANISATION'),
            content: (
              <OrganisationArea entity={entityType} table={dataTable.table} />
            ),
            resizable: true,
            collapsible: true,
            custom: true,
          },
        },
      }}
    />
  );
}
